<button class="a7-button-override"
        (click)="onClick($event)"
        matRipple
        [matRippleColor]="RippleColor[theme]"
        [ngClass]="classes"
        (mouseover)="state = 'hovered'"
        (mouseleave)="state = 'standard'"
        (mousedown)="state = 'pressed'"
        (mouseup)="state = 'hovered'">
  <a7-loading-content [progressor]="progressor">
    <a7-spin-loading-indicator errorMessage="failed"
                               a7-loading-indicator>
    </a7-spin-loading-indicator>
    <div class="flex-row-center-center">
      <img *ngIf="icon"
           class="v2-margin-8px-r"
           [ngClass]="size == 'small' || theme == 'text-medium' ? 'v2-w-20px' : 'v2-w-24px'"
           [src]="icon">
      <ng-content></ng-content>
    </div>
  </a7-loading-content>
</button>
